import { SITE_CONFIG } from "../siteConfig.js";
import { LegalDocument } from "./LegalDocument.js";

/** Privacy policy matching what the site really collects. Draft: lawyer review required. */
export function privacyDocument(cfg = SITE_CONFIG): LegalDocument {
  return new LegalDocument("Privacy policy", cfg.legalUpdated, [
    {
      heading: "What we collect",
      paragraphs: [
        "The only personal information this site collects is what you type into the quote, free sample and contact forms: your name, your email address, and the project details you write (product category, budget range, package, number of products, notes, and for free sample requests a product link and photo links).",
        "We do not ask you to create an account, we do not take payments on this website, and you cannot upload files here. If you send photo links, we only open those links to do the work you asked for.",
      ],
    },
    {
      heading: "Cookies and tracking",
      paragraphs: [
        "This site does not set advertising or analytics cookies and does not run third-party analytics or advertising scripts. Our hosting and API providers may keep standard server logs (such as IP address and request time) for security and reliability.",
      ],
    },
    {
      heading: "Why we use it",
      paragraphs: [
        "We use your details only to reply to you, prepare quotes or samples, and deliver the work you order. We do not sell your information and we do not use it for marketing unless you ask us to.",
      ],
    },
    {
      heading: "Who processes it",
      paragraphs: [
        "Form submissions are sent over HTTPS to the Lumora platform API, which stores them in its database on our behalf and is hosted on Render. The website itself is served by Cloudflare Pages. If a notification email is sent, it goes through the platform's email provider. Delivery of finished files may use a file-sharing service you can see in the download link. These providers handle data only to provide their service to us.",
      ],
    },
    {
      heading: "How long we keep it",
      paragraphs: [
        "Enquiries that do not become a project are kept for up to 12 months, then deleted. Project records are kept as long as needed for invoicing, tax and legal reasons. [Retention periods to be confirmed with a lawyer.]",
      ],
    },
    {
      heading: "Your choices",
      paragraphs: [
        `You can ask to see, correct or delete your information at any time by emailing ${cfg.contactEmail}. Depending on where you live you may have further rights, for example under GDPR or CCPA.`,
      ],
    },
    {
      heading: "Children and changes",
      paragraphs: [
        "This service is for businesses and is not aimed at children. If we change what we collect, we will update this page and the date above.",
      ],
    },
  ]);
}
